import React from 'react'

const Header = () => {
    return (
        <header className="header">
            <div className="container-title">
            <div className="img">
            <img className="logo" src="calculator-logo.png" width="50" height="50" alt="logo" />
            </div>
            <h1 className='title'>Comms Calculator</h1>
            </div>
        </header>
    )
}

export default Header
